class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    if (!this.notification) return;

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    if (!this.notification) return;

    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    if (!this.notification) return;

    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const sectionHtml = parsedState.sections && parsedState.sections[section.id];

      if (!target || !sectionHtml) return;

      const newHtml = this.getSectionInnerHTML(sectionHtml, section.selector);

      if (newHtml !== null) {
        target.innerHTML = newHtml;
      }
    });

    if (this.header) this.header.reveal();

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);

    return element ? element.innerHTML : null;
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}